import { createContext, Dispatch, SetStateAction } from 'react'

import { UnifiedPerson, UnifiedPersonFilterKeyString } from 'CitizenProfile/types'
import { UNIFIED_PERSON_INITIAL_FILTER } from 'CitizenProfile/constants/pages/unifiedPeople'

type CustomFormUnifiedPersonSelectionDrawerManagerContextType = {
  view: string
  setView: Dispatch<SetStateAction<string>>
  selectedUnifiedPerson: UnifiedPerson
  setSelectedUnifiedPerson: (newUnifiedPerson: UnifiedPerson) => void
  filter: UnifiedPersonFilterKeyString
  setFilter: Dispatch<SetStateAction<UnifiedPersonFilterKeyString>>
  questionKey: string
  unifiedPeople: UnifiedPerson[]
  invalidUnifiedPerson: boolean
  loadingUnifiedPeople: boolean
}

const defaultValue = {
  view: '',
  setView: () => {},
  selectedUnifiedPerson: {},
  setSelectedUnifiedPerson: () => {},
  filter: UNIFIED_PERSON_INITIAL_FILTER,
  setFilter: () => {},
  questionKey: '',
  unifiedPeople: [],
  invalidUnifiedPerson: false,
  loadingUnifiedPeople: false,
}

const CustomFormUnifiedPersonSelectionDrawerManagerContext =
  createContext<CustomFormUnifiedPersonSelectionDrawerManagerContextType>(defaultValue)

export default CustomFormUnifiedPersonSelectionDrawerManagerContext
